import { without } from 'lodash';

import {
    CLOSE_PLATFORMS_PREVIEW,
    OPEN_PLATFORMS_PREVIEW,
    OpenPlatformsPreviewAction
} from '../actions/platformsPreviewEditor';
import {
    CLOSE_PLATFORM_PREVIEW_HEADER,
    OPEN_PLATFORM_PREVIEW_HEADER,
    OpenPlatformPreviewHeaderAction
} from '../actions/platformsPreviewHeader';
import { PlatformsPreviewEditorState } from '../typings/displayMap';
import { GroupType } from '../typings/domain';
import { PlatformsPreviewEditorsState } from '../typings/state';

export const defaultPlatformsPreviewEditorState: PlatformsPreviewEditorState = {
    isOpen: false,
    openedRegions: [],
    type: GroupType.CPM_OUTDOOR
};

export const platformsPreviewEditorInitialState: PlatformsPreviewEditorsState = {};

export function platformsPreviewEditor(
    state: PlatformsPreviewEditorsState = platformsPreviewEditorInitialState,
    action: OpenPlatformsPreviewAction | OpenPlatformPreviewHeaderAction
): PlatformsPreviewEditorsState {
    switch (action.type) {
        case OPEN_PLATFORMS_PREVIEW: {
            const editor = state[action.groupId] || {
                ...defaultPlatformsPreviewEditorState,
                type: action.previewType
            };

            return {
                ...state,
                [action.groupId]: {
                    ...editor,
                    isOpen: true
                }
            };
        }

        case CLOSE_PLATFORMS_PREVIEW: {
            const editor = state[action.groupId];

            return {
                ...state,
                [action.groupId]: {
                    ...editor,
                    isOpen: false
                }
            };
        }

        case OPEN_PLATFORM_PREVIEW_HEADER: {
            const editor = state[action.groupId] || {
                ...defaultPlatformsPreviewEditorState,
                type: action.previewType
            };
            const openedRegions = editor.openedRegions;
            const regionId = action.regionId;

            return {
                ...state,
                [action.groupId]: {
                    ...editor,
                    openedRegions: openedRegions.includes(regionId)
                        ? openedRegions
                        : openedRegions.concat(regionId)
                }
            };
        }

        case CLOSE_PLATFORM_PREVIEW_HEADER: {
            const editor = state[action.groupId];
            const openedRegions = editor.openedRegions;
            const regionId = action.regionId;

            return {
                ...state,
                [action.groupId]: {
                    ...editor,
                    openedRegions: without(openedRegions, regionId)
                }
            };
        }

        default:
            return state;
    }
}
